export default __webpack_public_path__ + "static/media/S0020-Figure_6.1.1658498700000.c1506aa6.jpg";